import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMobile = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={15} height={18} fill='none' {...props}>
    <path
      stroke='#323E54'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M14 5v8c0 3.2-.8 4-4 4H5.2c-3.2 0-4-.8-4-4V5c0-3.2.8-4 4-4H10c3.2 0 4 .8 4 4M9.2 3.8H6'
    />
    <path
      stroke='#323E54'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M7.6 14.68a1.24 1.24 0 1 0 0-2.48 1.24 1.24 0 0 0 0 2.48'
    />
  </svg>
);
export default SvgMobile;
